module.exports = __webpack_public_path__ + "assets/pisa.567772df.svg";